import { render, staticRenderFns } from "./SliderTicket.vue?vue&type=template&id=2dd0f4c4&scoped=true&"
import script from "./SliderTicket.vue?vue&type=script&lang=js&"
export * from "./SliderTicket.vue?vue&type=script&lang=js&"
import style0 from "./SliderTicket.vue?vue&type=style&index=0&id=2dd0f4c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0f4c4",
  null
  
)

export default component.exports